import { createFileRoute } from '@tanstack/react-router';
import { t } from 'utils/routeTitle';

import Sites from 'component/view/Sites';

import { requireActivePlan } from './-guards';

export const Route = createFileRoute('/n/_auth/sites/')({
  staticData: { routeTitle: t('common.sites') },
  beforeLoad: requireActivePlan,
  component: Sites,
});
